module.exports = __webpack_public_path__ + "static/media/20s_female_actors_temp.a1f34152.jpg";